'use client'

import { NexperienceAvailableDatesDocument } from '@data-access/lib/gql/experience/documents'
import { useGraphQL } from '@data-access/lib/graphql-query'
import { keepPreviousData } from '@tanstack/react-query'
import {
  EXPERIENCE_AVAILABILITY_STALE_TIME,
  getExperienceAvailableDatesVariables,
} from '../_lib/experience-availability-query'
import type { SelectedOptions } from '../_lib/experience-state-types'
import { useExperiencePreviewToken } from './use-experience-preview-token'

export function useAppExperienceAvailableDates(
  publicId: number,
  variantId?: string | null,
  selectedOptions?: SelectedOptions | null,
  enabled = true
) {
  const previewToken = useExperiencePreviewToken()
  const variables = getExperienceAvailableDatesVariables({
    publicId,
    previewToken,
    selectedVariant: variantId,
    selectedOptions,
  })

  const {
    data,
    isLoading,
    isPlaceholderData,
    isError,
    isFetching,
    refetch,
    errorUpdatedAt,
    dataUpdatedAt,
  } = useGraphQL(NexperienceAvailableDatesDocument, variables, {
    select: response => response.nexperienceAvailableDates.dates.map(date => date.date),
    enabled: enabled && !!variantId,
    placeholderData: keepPreviousData,
    staleTime: EXPERIENCE_AVAILABILITY_STALE_TIME,
  })

  return {
    availableDates: data,
    isLoading,
    isError: isError || (isFetching && errorUpdatedAt > dataUpdatedAt),
    isFetching,
    refetch,
    isPreliminary: isPlaceholderData,
  }
}
